import IAnalyticsService from '../../../services/AnalyticsService/IAnalyticsService';
import { AnalyticsInterfaceType } from '@clientos/types';
import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';

class AnalyticsInterface {
  private _analyticsService: IAnalyticsService;

  constructor() {
    const services = getServices();
    this._analyticsService = services.analyticsService;
    bindAllMethods(this);
  }

  // keep compatibility.
  private async _isEnabled(): Promise<boolean> {
    return this._analyticsService.isEnabled();
  }

  public getInterface(): AnalyticsInterfaceType {
    return {
      publishCdmEvents: this._analyticsService.publishCdmEvents,
      isEnabled: this._isEnabled
    };
  }
}

export default AnalyticsInterface;
